<template>
  <div>
    <!-- <div>
      <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

    </div> -->
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <!-- begin                                                                         -->
    <v-card class="box">
      <v-row fluid justify="center">
        <v-radio-group v-model="check_in_type" row>
          <v-radio label="Check-Out by ID-Card" value="ICard" @change="hideIcard"></v-radio>
          <v-radio label="Visitor Check-Out" @change="hideVisitor" value="Visitor"></v-radio>
        </v-radio-group>
      </v-row>
      <template v-if="check_in_type == 'ICard'">
        <v-row dense>
          <v-col cols="12" sm="3" md="3"></v-col>
          <v-col cols="12" sm="6" md="6">
            <v-text-field outlined dense label="User-Id/PRno/Emp-code" type="text" v-model="user"></v-text-field>
          </v-col>

          <v-col cols="12" sm="3" md="3">
            <v-btn class="button" @click="fetchUser('ID-Card')">Fetch</v-btn>
          </v-col>
        </v-row>
        <v-card class="box1" id="idCard" v-if="visitor_visit_data !== null">
          <div class="header">
            <v-row v-if="org_basic_data != null">
              <!-- <v-col cols="12" sm="2" md="2"></v-col> -->
              <v-col cols="12" sm="3" md="3" align="left">
                <img :src="org_basic_data.trust_logo" alt="" style="width: 100%; height: 100%" />
              </v-col>
              <v-col cols="12" sm="9" md="9">
                <h3>
                  {{ org_basic_data.trust_name }}
                </h3>
                <span style="font-size: 16px">
                  {{ org_basic_data.school_name }} <br />
                </span>
                <span>{{ org_basic_data.address }}</span><br />
                <span v-html="org_basic_data.line1"></span><br />
                <span v-html="org_basic_data.line2"></span><br />
              </v-col>
            </v-row>
          </div>
          <v-row dense v-if="visitor_photo != null">
            <v-col cols="12" sm="5" md="5"></v-col>
            <v-col cols="12" sm="3" md="3">
              <v-img style="width: 250px; height: 155px" class="shrink mr-2" :src="awspath + visitor_photo"></v-img>
            </v-col>
          </v-row>
          <v-row dense v-if="visitor_username != null">
            <v-col cols="12" sm="1" md="1"></v-col>

            <v-col cols="12" sm="11" md="11">
              <center>
                <span style="font-weight: 500">Emp Code / PRN / User ID: {{ visitor_username }}</span>
                <br />
                <span style="font-weight: 500">{{ visitor_name }}</span> <br />
                <span style="font-weight: 500">{{ visitor_usertype }}</span>
                <br /><br />
              </center>
            </v-col>
          </v-row>
          <v-row dense justify="center">
            <v-col cols="12" sm="12" md="6">
              <p><b>Check-In Date and Time</b></p>
              <v-text-field outlined dense v-model="visitor_visit_data.checkintime" readonly filled></v-text-field>
            </v-col>
          </v-row>
          <v-row dense v-if="visitor_visit_data.checkouttime !== null" justify="center">
            <v-col cols="12" sm="12" md="6">
              <p><b>Check-Out Date and Time</b></p>

              <v-text-field outlined dense v-model="visitor_visit_data.checkouttime" readonly filled></v-text-field>
            </v-col>
          </v-row>
        </v-card>
        <br />
        <v-row dense v-if="visitor_visit_data != null" justify="center" id="idCard">
          <v-btn class="info" @click="checkOut">Check-Out</v-btn>
        </v-row>
        <!-- {{ visitor_visit_data }} <br /> -->
      </template>

      <!-- visitor -->
      <template v-if="check_in_type == 'Visitor'">
        <!-- [Visitor] -->
        <v-row dense>
          <v-col cols="12" sm="3" md="3"></v-col>
          <v-col cols="12" sm="6" md="6">
            <v-autocomplete color="#0F2027" dense rounded required v-model="visitor_mobile" :items="visitors_list"
              item-text="visitor_mob_name" return-object label="Search visitors by mobile no And Name" clearable
              outlined />
          </v-col>

          <v-col cols="12" sm="3" md="3">
            <v-btn class="button" @click="fetchUser('Visitor')">Fetch</v-btn>
          </v-col>
        </v-row>
        <v-card class="box1" id="r_visitor" v-if="visitor_visit_data !== null">
          <div class="header">
            <v-row v-if="org_basic_data != null">
              <!-- <v-col cols="12" sm="2" md="2"></v-col> -->
              <v-col cols="12" sm="3" md="3" align="left">
                <img :src="org_basic_data.trust_logo" alt="" style="width: 100%; height: 100%" />
              </v-col>
              <v-col cols="12" sm="9" md="9">
                <h3>
                  {{ org_basic_data.trust_name }}
                </h3>
                <span style="font-size: 16px">
                  {{ org_basic_data.school_name }} <br />
                </span>
                <span>{{ org_basic_data.address }}</span><br />
                <span v-html="org_basic_data.line1"></span><br />
                <span v-html="org_basic_data.line2"></span><br />
              </v-col>
            </v-row>
          </div>
          <v-row dense v-if="visitor_photo != null">
            <v-col cols="12" sm="5" md="5"></v-col>
            <v-col cols="12" sm="3" md="3">
              <v-img style="width: 250px; height: 155px" class="shrink mr-2" :src="awspath + visitor_photo"></v-img>
            </v-col>
          </v-row>
          <v-row dense v-if="visitor_mobile != null">
            <v-col cols="12" sm="1" md="1"></v-col>

            <v-col cols="12" sm="11" md="11">
              <center>
                <span style="font-weight: 500">Emp Code / PRN / User ID: {{ visitor_mobile_added }}</span>
                <br />
                <!-- <span style="font-weight: 500">{{ visitor_name }}</span> <br /> -->
                <span style="font-weight: 500">{{ visitor_usertype }}</span>
              </center>
            </v-col>
          </v-row>
          <v-row dense justify="center">
            <v-col cols="12" sm="12" md="6">
              <p><b>Name</b></p>
              <v-text-field outlined dense v-model="visitor_visit_data.visitor_data.visitor_name" readonly
                filled></v-text-field>
            </v-col>
          </v-row>
          <v-row dense justify="center">
            <v-col cols="12" sm="12" md="6">
              <p><b>Address</b></p>
              <v-text-field outlined dense v-model="visitor_visit_data.visitor_data.visitor_address" readonly
                filled></v-text-field>
            </v-col>
          </v-row>

          <v-row dense justify="center">
            <v-col cols="12" sm="12" md="6">
              <p><b>Check-In Date and Time</b></p>
              <v-text-field outlined dense v-model="visitor_visit_data.checkintime" readonly filled></v-text-field>
            </v-col>
          </v-row>
          <v-row dense v-if="visitor_visit_data.checkouttime !== null" justify="center">
            <v-col cols="12" sm="12" md="6">
              <p><b>Check-Out Date and Time</b></p>

              <v-text-field outlined dense v-model="visitor_visit_data.checkouttime" readonly filled></v-text-field>
            </v-col>
          </v-row>
        </v-card>
        <br />
        <v-row dense id="r_visitor" v-if="visitor_visit_data != null" justify="center">
          <v-btn class="info" :disabled="visitor_visit_data.isrejected == 'Yes'" @click="checkOut">Check-Out</v-btn>
        </v-row>
        <template v-if="visitor_visit_data != null">
          <center>
            <h3 v-if="visitor_visit_data.isapproved == 'Yes'">Visitor Approved by {{ visitor_visit_data.approvalby }}
            </h3>
            <h3 v-if="visitor_visit_data.isrejected == 'Yes'">Visitor Rejected by {{ visitor_visit_data.approvalby }}
            </h3>
          </center>

        </template>
        <br>
        <!-- QR code check-out -->
        <template v-if="check_in_type == 'Visitor'">
          <v-row dense>
            <v-col cols="12" sm="3" md="3"></v-col>
            <v-col cols="12" sm="6" md="6">
              <v-text-field outlined rounded dense label="Enter URL" type="url" v-model="qrURL"></v-text-field>
            </v-col>
            <v-col cols="12" sm="3" md="3">
              <v-btn class="button" :loading="loading_url" @click="fetchUserformurl()">Fetch</v-btn>
            </v-col>
          </v-row>
        </template>
        <v-card class="box1" id="r_visitor" v-if="visitor_visit_data_url !== null">
          <div class="header">
            <v-row v-if="org_basic_data_url != null">
              <!-- <v-col cols="12" sm="2" md="2"></v-col> -->
              <v-col cols="12" sm="3" md="3" align="left">
                <img :src="org_basic_data_url.trust_logo" alt="" style="width: 100%; height: 100%" />
              </v-col>
              <v-col cols="12" sm="9" md="9">
                <h3>
                  {{ org_basic_data_url.trust_name }}
                </h3>
                <span style="font-size: 16px">
                  {{ org_basic_data_url.school_name }} <br />
                </span>
                <span>{{ org_basic_data_url.address }}</span><br />
                <span v-html="org_basic_data_url.line1"></span><br />
                <span v-html="org_basic_data_url.line2"></span><br />
              </v-col>
            </v-row>
          </div>
          <v-row dense v-if="visitor_photo_url != null">
            <v-col cols="12" sm="5" md="5"></v-col>
            <v-col cols="12" sm="3" md="3">
              <v-img style="width: 250px; height: 155px" class="shrink mr-2" :src="awspath + visitor_photo_url"></v-img>
            </v-col>
          </v-row>
          <v-row dense v-if="visitor_mobile_added_url != null">
            <v-col cols="12" sm="1" md="1"></v-col>

            <v-col cols="12" sm="11" md="11">
              <center>
                <span style="font-weight: 500">Emp Code / PRN / User ID: {{ visitor_mobile_added_url }}</span>
                <br />
                <!-- <span style="font-weight: 500">{{ visitor_name }}</span> <br /> -->
                <span style="font-weight: 500">{{ visitor_usertype_url }}</span>
              </center>
            </v-col>
          </v-row>
          <v-row dense justify="center">
            <v-col cols="12" sm="12" md="6">
              <p><b>Name</b></p>
              <v-text-field outlined dense v-model="visitor_visit_data_url.visitor_data.visitor_name" readonly
                filled></v-text-field>
            </v-col>
          </v-row>
          <v-row dense justify="center">
            <v-col cols="12" sm="12" md="6">
              <p><b>Address</b></p>
              <v-text-field outlined dense v-model="visitor_visit_data_url.visitor_data.visitor_address" readonly
                filled></v-text-field>
            </v-col>
          </v-row>

          <v-row dense justify="center">
            <v-col cols="12" sm="12" md="6">
              <p><b>Check-In Date and Time</b></p>
              <v-text-field outlined dense v-model="visitor_visit_data_url.checkintime" readonly filled></v-text-field>
            </v-col>
          </v-row>
          <v-row dense v-if="visitor_visit_data_url.checkouttime !== null" justify="center">
            <v-col cols="12" sm="12" md="6">
              <p><b>Check-Out Date and Time</b></p>

              <v-text-field outlined dense v-model="visitor_visit_data_url.checkouttime" readonly filled></v-text-field>
            </v-col>
          </v-row>
        </v-card>
        <br />
        <v-row dense id="r_visitor" v-if="visitor_visit_data_url != null" justify="center">
          <v-btn class="info" :disabled="visitor_visit_data_url.isrejected == 'Yes'"
            @click="checkOutbyurl">Check-Out</v-btn>
        </v-row>
        <template v-if="visitor_visit_data_url != null">
          <center>
            <h3 v-if="visitor_visit_data_url.isapproved == 'Yes'">Visitor Approved by {{
              visitor_visit_data_url.approvalby
              }}
            </h3>
            <h3 v-if="visitor_visit_data_url.isrejected == 'Yes'">Visitor Rejected by {{
              visitor_visit_data_url.approvalby
              }}
            </h3>
          </center>

        </template>

      </template>
    </v-card>
  </div>
</template>

<script>
import axios from "axios";
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
  components: {
    Breadcrumbs,
  },
  data: () => ({
    snackbar_msg: "",
    color: "",
    snackbar: false,
    overlay: false,
    awspath: null,
    visitors_list: [],
    ///////////////////////////////////////////////
    visitor_mobile: null,
    // extraBreadcrumbItems: [
     

    // ],
    // breadcrumbClass: "breadcrumb-style1",
    visitor_mobile_url: null,
    visitor_mobile_added: null,
    visitor_mobile_added_url: null,
    check_in_type: null,
    user: null,
    loading_url: false,
    qrURL: null,
    org_basic_data: null,
    org_basic_data_url: null,
    visitor_username_url: null,
    visitor_username: null,
    visitor_usertype_url: null,
    visitor_usertype: null,
    visitor_photo_url: null,
    visitor_photo: null,
    visitor_name_url: null,
    visitor_name: null,
    visitor_visit_data_url: null,
    visitor_visit_data: null,
  }),
  mounted() {
    this.awspath = localStorage.getItem("awspath");
    this.onload();
  },
  methods: {
    onload() {
      axios
        .post("/visitorManagement/getAllVisitors")
        .then((res) => {
          console.log("res:", res.data);
          if (res.data.flag == "YES") {
            this.overlay = false;
            this.visitors_list = res.data.visitors_list;
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
            this.overlay = false;
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.onerror(error);

          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
          // this.selected_date=""
        });
    },
    hideVisitor() {
      var element = document.getElementById("idCard");
      element.style.display = "none";
      this.reset();
    },
    hideIcard() {
      var element = document.getElementById("r_visitor");
      element.style.display = "none";
      this.reset();
    },

    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
    onerror(error) {
      let msg = "";
      if (error.response) {
        msg = "Something went wrong.";
      } else if (error.request) {
        msg = "Please try again.";
      } else {
        msg = "Un-expected error.";
      }
      this.showSnackbar("error", msg);
    },
    /////////////////////////////////////////
    checkOut() {
      //  let form_check_in_dt = this.formatDate(this.check_in_dt, true);
      const formdata = {
        vvid: this.visitor_visit_data.vvid,
      };
      this.overlay = true;
      axios
        .post("/visitorManagement/checkout", formdata)
        .then((res) => {
          console.log("res:", res.data);
          if (res.data.flag == "YES") {
            this.overlay = false;
            this.showSnackbar("green", res.data.snackbar);
            // this.fetchUser();
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
            this.overlay = false;
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.onerror(error);

          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
          // this.selected_date=""
        });
    },
    reset() {
      this.visitor_username = null;
      this.visitor_photo = null;
      this.visitor_name = null;
      this.visitor_usertype = null;
      this.visitor_visit_data = null;
      this.visitor_mobile_added = null;
    },
    fetchUser(type) {
      this.reset();
      const formdata = {
        user: this.user,
        type: type,
      };
      if (type !== "ID-Card") {
        formdata.visitor_mobile = this.visitor_mobile.visitor_id;
      }
      this.overlay = true;
      axios
        .post("/visitorManagement/checkoutdata", formdata)
        .then((res) => {
          console.log("res:", res.data);
          if (res.data.flag == "YES") {
            this.overlay = false;
            this.org_basic_data = res.data.org_basic_data;
            this.visitor_username = res.data.visitor_username;
            this.visitor_mobile_added = res.data.visitor_mobile_added;
            this.visitor_photo = res.data.visitor_photo;
            this.visitor_name = res.data.visitor_name;
            this.visitor_usertype = res.data.visitor_usertype;
            this.visitor_visit_data = res.data.visitor_visit_data;
            this.showSnackbar("green", res.data.snackbar);
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.onerror(error);

          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
          // this.selected_date=""
        });
    },
    fetchUserformurl() {
      if (this.qrURL == null || this.qrURL == "") {
        this.showSnackbar("red", "Please Enter Url");
        this.loading_url = false;
        return;
      }
      try {
        const urlParams = new URLSearchParams(this.qrURL.split('?')[1]);
        const mob = urlParams.get('mob');
        const vvid = urlParams.get('vvid');
        const o = urlParams.get('o');
        const t = urlParams.get('t');

        const formdata = {
          mob: mob,
          vvid: vvid,
          o: o,
          t: t,
        };
        this.loading_url = true;
        axios.post("/visitorManagement/getcheckoutdatabyUrl", formdata)
          .then((res) => {
            console.log("res:", res.data);
            if (res.data.flag == "YES") {
              this.loading_url = false;
              this.org_basic_data_url = res.data.org_basic_data;
              this.visitor_username_url = res.data.visitor_username;
              this.visitor_mobile_added_url = res.data.visitor_mobile_added;
              this.visitor_photo_url = res.data.visitor_photo;
              this.visitor_name_url = res.data.visitor_name;
              this.visitor_usertype_url = res.data.visitor_usertype;
              this.visitor_visit_data_url = res.data.visitor_visit_data;
              this.showSnackbar("green", res.data.snackbar);
            } else {
              this.showSnackbar("red", res.data.snackbar);
              sessionStorage.setItem("error-trace", res.data.error_trace);
            }
            this.loading_url = false;
          });
      } catch (error) {
        this.showSnackbar("red", error,);

      }
    },
    checkOutbyurl() {
      //  let form_check_in_dt = this.formatDate(this.check_in_dt, true);
      const formdata = {
        vvid: this.visitor_visit_data_url.vvid,
      };
      this.overlay = true;
      axios
        .post("/visitorManagement/checkout", formdata)
        .then((res) => {
          console.log("res:", res.data);
          if (res.data.flag == "YES") {
            this.overlay = false;
            this.showSnackbar("green", res.data.snackbar);
            // this.fetchUser();
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
            this.overlay = false;
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.onerror(error);

          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
          // this.selected_date=""
        });
    },
  },
};
</script>

<style scoped>
.box1 {
  background-color: white !important;
  /* margin: 8px !important;
  padding: 8px; */
  border: 2px solid #8360c3 !important;
  width: 45%;
  margin-left: 28%;
}

.header span {
  font-weight: 500;
  font-size: 13px;
}

.button {
  margin: 0 !important;
}
</style>